import * as React from 'react';
import {Typography, WithStyles, withStyles,} from '@material-ui/core';
import { EcoRepeat, IEcoAgreement, IEcoPurchase} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import { ecoContainerStyle } from './Container.style';
import { default as AddIcon } from '@material-ui/icons/Add';
import TranslateNew from "@translate/TranslateNew";
import ListItemApprovedAgreement from './ListItemApprovedAgreement';
import Button from '@components/common/button/Button';
import { getWeekNum } from '@helpers/DateHelper';

const tn = TranslateNew.getInstance();

interface IApprovedAgreementsProps extends WithStyles<typeof ecoContainerStyle>
{
    agreements: IEcoAgreement[];
    family: IFamilyMember[];
    userId: number;
    currency:string;
    edit: (agreement:IEcoAgreement) => void;
    complete: (agreement:IEcoAgreement) => void;
    seen: (id:number) => void;
    scrollTime:number;
    toggleSetupWizard: () => void;
}

interface IApprovedAgreementsState
{
    hideTooltip: boolean;
}

class ContainerApprovedAgreements extends React.Component<IApprovedAgreementsProps, IApprovedAgreementsState> {

    constructor(props:IApprovedAgreementsProps) {
        super(props);

        this.state = {
            hideTooltip: false,
        };
    }

    public render() {
        const { classes, agreements,toggleSetupWizard, userId } = this.props;

        const veryurgent:IEcoAgreement[] = [];
        const urgent:IEcoAgreement[] = [];
        const futureList:IEcoAgreement[] = [];
        const isMyResponsibility = (agreement:IEcoAgreement) =>
            agreement.responsible.length === 0 || agreement.responsible.includes(userId);

        const now = Date.now();
        const nowWeek = getWeekNum(new Date());
        const nowMonth = (new Date()).getMonth();
        const nowQuarter = tn.lang.getQuarterName((new Date()));
        const nowTerm = tn.lang.getTermName((new Date()));
        const nowYear = (new Date()).getFullYear();

        for (const agr of agreements) {
            
            if (agr.repeat === EcoRepeat.WEEKLY) {
                const forName = getWeekNum(new Date(agr.forDate));
                if (forName === nowWeek) {
                    urgent.push(agr);
                } else {
                    if (agr.forDate > now) {
                        futureList.push(agr);
                    } else {
                        veryurgent.push(agr);
                    }
                }
            } else if (agr.repeat === EcoRepeat.MONTHLY) {
                const forName = (new Date(agr.forDate)).getMonth();

                if (forName === nowMonth) {
                    urgent.push(agr);
                } else {
                    if (agr.forDate > now) {
                        futureList.push(agr);
                    } else {
                        veryurgent.push(agr);
                    }
                }
            } else if (agr.repeat === EcoRepeat.QUARTERLY) {
                const forName = tn.lang.getQuarterName((new Date(agr.forDate)));
                if (forName === nowQuarter) {
                    urgent.push(agr);
                } else {
                    if (agr.forDate > now) {
                        futureList.push(agr);
                    } else {
                        veryurgent.push(agr);
                    }
                }
            } else if (agr.repeat === EcoRepeat.TERM) {
                const forName = tn.lang.getTermName((new Date(agr.forDate)));
                if (forName === nowTerm) {
                    urgent.push(agr);
                } else {
                    if (agr.forDate > now) {
                        futureList.push(agr);
                    } else {
                        veryurgent.push(agr);
                    }
                }
            } else if (agr.repeat === EcoRepeat.YEARLY) {
                const forName = (new Date(agr.forDate)).getFullYear();
                if (forName === nowYear) {
                    urgent.push(agr);
                } else {
                    if (agr.forDate > now) {
                        futureList.push(agr);
                    } else {
                        veryurgent.push(agr);
                    }
                }
            } else  {
                urgent.push(agr);
            } 
        }

        urgent.sort(repeatOrder);
        futureList.sort(repeatOrder);
        
        const urgentList:IEcoAgreement[] = veryurgent.concat(urgent);
        const myResponsibility = urgentList.filter(isMyResponsibility).length;
        let passedUrgent = 0;

        const urgentComponent = urgentList.length > 0 
            ?<div className={classes.card}>
                {urgentList.map((agreement, index) => 
                    {
                        if (isMyResponsibility(agreement)) {passedUrgent++;}
                        return(<ListItemApprovedAgreement key={""+index}
                            agreement={agreement}
                            family={this.props.family}
                            userId={this.props.userId}
                            currency={this.props.currency}
                            editAgreement={this.props.edit}
                            completeAgreement={this.props.complete}
                            seenAgreement={this.props.seen}
                            scrollTime={this.props.scrollTime}
                            tooltip={!this.state.hideTooltip && isMyResponsibility(agreement) && passedUrgent === myResponsibility}
                            hideTooltip={() => this.setState({hideTooltip:true})}
                        />);
                    }
                )}
            </div>
            :undefined;

        return (
            <div className={classes.container}>
                {agreements.length > 0 && <div className={classes.titleWrapper}>
                    <Typography className={classes.heading1} gutterBottom={false}>{tn.lang.upcomingPurchases}</Typography>
                </div>}            
                
                {urgentComponent}

                {futureList.length > 0 && <div className={classes.titleWrapper}>
                        <Typography className={classes.heading1} gutterBottom={false}>
                            {tn.lang.upcomingPurchasesNonUrgent}
                        </Typography>
                    </div>}
                
                {futureList.length > 0 &&
                    <div className={classes.card}>
                        {futureList.map((agreement, index) => (
                            <ListItemApprovedAgreement key={""+index}
                                agreement={agreement}
                                family={this.props.family}
                                userId={this.props.userId}
                                currency={this.props.currency}
                                editAgreement={this.props.edit}
                                completeAgreement={this.props.complete}
                                seenAgreement={this.props.seen}
                                scrollTime={this.props.scrollTime}
                                hideTooltip={() => this.setState({hideTooltip:true})}
                            />
                        ))}
                    </div>}
            </div>
        );
    }

    
}

function repeatOrder(a: IEcoAgreement, b: IEcoAgreement)  {
    const aRepeat = getRepeatOrder(a.repeat);
    const bRepeat = getRepeatOrder(b.repeat);

    if (aRepeat === bRepeat) {
        const forDate = (Math.round(a.forDate/100000) - Math.round(b.forDate/100000));
        if (forDate !== 0) {
            return forDate;
        } else {
            return a.title.localeCompare(b.title);
        }
    } else {
        return aRepeat-bRepeat;
    }
}

function getRepeatOrder(repeat:EcoRepeat) {
    switch (repeat) {
        case EcoRepeat.ONCE:
          return 1;
        case EcoRepeat.WEEKLY:
          return 2;
        case EcoRepeat.MONTHLY:
          return 3;
        case EcoRepeat.QUARTERLY:
          return 4;
        case EcoRepeat.YEARLY:
          return 5;
        case EcoRepeat.TERM:
          return 6;
        default:
          return 7;
      }
}

export default withStyles(ecoContainerStyle)(ContainerApprovedAgreements);



// WEBPACK FOOTER //
// ./src/components/economy/ContainerApprovedAgreements.tsx